/**
 * URLs for the Tours fixture assets that are safe to render from the isolated
 * Preview application.
 *
 * Preview deliberately uses its own Supabase project.  Its catalog is local
 * so device QA can be deterministic, but a local `localhost:5055` cover
 * server is not reachable from a physical phone.  Bind the object URL to the
 * runtime's own Supabase origin instead of trusting a developer machine or a
 * copied production URL, and fail closed when this preview-only data module is
 * ever reached from the production package.
 *
 * EL PROYECTO DE FIXTURES NO SE ESCRIBE ACA. Estaba hardcodeado y este modulo
 * viaja en el bundle de produccion (preview/data.ts lo importa), asi que el ref
 * de fixtures terminaba embebido en app.tago.rent — y el guard de dist lo
 * rechazaba, con razon, en cada build de produccion. El origen sale del propio
 * `supabaseUrl` del runtime, que ya es la unica fuente de configuracion; la
 * identidad aislada y la forma del host (proyecto Supabase directo, nunca el
 * dominio de produccion) mantienen el fallo cerrado.
 */
const SUPABASE_PROJECT_HOST = /^[a-z]{20}\.supabase\.co$/
const TOURS_COVERS_PUBLIC_PATH = '/storage/v1/object/public/tours-covers'
const SAFE_TOUR_COVER_SLUG = /^[a-z0-9][a-z0-9-]{0,120}$/
const SAFE_TOUR_GALLERY_ID = /^[a-z0-9][a-z0-9-]{0,120}$/

function trustedFixtureOrigin(input: {
  supabaseUrl: string
  isIsolatedPreviewBuild: boolean
}): string | null {
  if (!input.isIsolatedPreviewBuild) return null
  try {
    // `origin` is canonicalized by URL, so a path/query from a malformed
    // runtime config can never change where the asset is fetched from.
    const origin = new URL(input.supabaseUrl).origin
    if (!SUPABASE_PROJECT_HOST.test(new URL(origin).hostname)) return null
    return origin
  } catch {
    return null
  }
}

export function previewToursCoverUrl(
  slug: string,
  input: { supabaseUrl: string; isIsolatedPreviewBuild: boolean },
): string | null {
  const origin = trustedFixtureOrigin(input)
  if (!origin || !SAFE_TOUR_COVER_SLUG.test(slug)) return null

  return `${origin}${TOURS_COVERS_PUBLIC_PATH}/${encodeURIComponent(slug)}.webp`
}

/**
 * Gallery media is fixture-bound by the same runtime identity as the cover.
 * A copied preview database can therefore never render production gallery
 * objects, even when its JSON happens to carry their object keys.
 */
export function previewToursGalleryUrl(
  slug: string,
  photoId: string,
  input: { supabaseUrl: string; isIsolatedPreviewBuild: boolean },
): string | null {
  const origin = trustedFixtureOrigin(input)
  if (!origin || !SAFE_TOUR_COVER_SLUG.test(slug) || !SAFE_TOUR_GALLERY_ID.test(photoId)) {
    return null
  }

  return `${origin}${TOURS_COVERS_PUBLIC_PATH}/gallery/${encodeURIComponent(slug)}/${encodeURIComponent(photoId)}.webp`
}
